import React from 'react';
import { FilesDropzone } from 'components';
import { makeStyles } from '@mui/styles';
import { Grid } from '@mui/material';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3),
	},
	container: {
		marginTop: theme.spacing(3),
	}
}));

const NominationPDFForm = (props) => {
	const classes = useStyles();

	return (
		<div className={classes.fields}>
			<Grid container spacing={2}>
				<Grid item md={8} xs={8}>
					<FilesDropzone acceptedTypes=".xlsx" />
				</Grid>
			</Grid>
		</div>
	);
};

export default NominationPDFForm;
